import { LeadActions } from "redux/actions/leadActions";

const initialState = {
    data: null,
    error: null,
    isLoading: false,
};

const leadReducer = (state = initialState, action) => {
    switch (action.type) {
        case LeadActions.UPDATE_DATA:
            return {
                ...state,
                data: action.payload,
            };
        default:
            return initialState;
    }
};

export default leadReducer;
